















































































import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyCheckAmountKey from "@/components/company-check-amout-key";
import CompanyKey from "@/components/company-key";
export default createComponent({
   setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyCheckAmount = inject(CompanyCheckAmountKey);
    if (!companyCheckAmount) {
      throw new Error(`${CompanyCheckAmountKey} is not provided`);
    }

    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const date = window.location.pathname.split('/')[4]
    const getPaymentInfor = companyCheckAmount.getPaymentInfor
    onMounted(() => {
      company.getCompanyInfor()
      getPaymentInfor(date)
      companyCheckAmount.getJobSettlement(date)
    });
    const agreementDate  = window.location.pathname.split('/')[4].split('-')
    const paymentInfor = computed(() => companyCheckAmount.amountInfor) as any;
    const paymentArr = computed(() => companyCheckAmount.amountInfor.paymentPreview)  as any;
    let handleData = computed(() => companyCheckAmount.amountInfor.jobPayment) as any;
    const print = computed(() => companyCheckAmount.print);
    const companyName = computed(()=> company.companyInformation.companyInforList.company_name)
    const formatNumber = (number: string) => displayui.formatNumber(number)
    const totalDaily = computed(() => {
      var sum:number = 0;
      // @ts-ignorey
      companyCheckAmount.amountInfor.jobPayment.forEach(item => sum += parseInt(item.total_daily_amt.replace(/,/g, '')))
      // @ts-ignorey
      return sum;
    });
    const totalSettlement = computed(() => {
      var sum:number = 0;
      // @ts-ignorey
      companyCheckAmount.amountInfor.jobPayment.forEach(item => sum += parseInt(item.total_settle_amt.replace(/,/g, '')))
      // @ts-ignorey
      return sum;
    })
    return {
      handleData,
      print,
      agreementDate,
      paymentInfor,
      paymentArr,
      companyName,
      formatNumber,
      totalDaily,
      totalSettlement,
    };
  },
 
})
